module.exports = __webpack_public_path__ + "img/reservoirs-of-quiet.8151d38a.png";